module.exports = __webpack_public_path__ + "static/img/about-us-banner-title.4b39fcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about-us-banner-title.png
// module id = DrUy
// module chunks = 0